import { Table } from "reactstrap"
import PropTypes from "prop-types"

const SimpleTable2 = props => {
  const { isLoading, tableClasses, tableInnerClasses, tHeads, tBodies } = props
  return (
    <div className={tableClasses}>
      <Table className={`table ${tableInnerClasses} mb-0`}>
        {isLoading && (
          <thead>
            <tr>
              <th>
                <span className="placeholder col-10"></span>
              </th>
            </tr>
          </thead>
        )}
        {isLoading && (
          <tbody>
            <tr>
              <td>
                <span className="placeholder col-10"></span>
              </td>
            </tr>
          </tbody>
        )}
        {!isLoading && (
          <thead>
            {tHeads.map((el, key) => (
              <tr key={key} className={el?.classNames}>
                {el?.ths.map((subEl, subKey) => (
                  <th
                    key={subKey}
                    colSpan={subEl?.colSpan}
                    rowSpan={subEl?.rowSpan}
                  >
                    {subEl.cell}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
        )}
        {!isLoading && (
          <tbody>
            {tBodies.map((el, key) => (
              <tr key={key} className={el?.classNames}>
                {el?.tds.map((subEl, subKey) => (
                  <td key={subKey} className={subEl?.classNames}>
                    {subEl?.cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        )}
      </Table>
    </div>
  )
}

SimpleTable2.propTypes = {
  isLoading: PropTypes.bool,
  tableClasses: PropTypes.string,
  tableInnerClasses: PropTypes.string,
  tHeads: PropTypes.array,
  tBodies: PropTypes.array,
}

export default SimpleTable2
